import { Icon, IconProps } from "../";

export const ArrowDoubleRightIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.46967 7.53033C6.17678 7.23744 6.17678 6.76256 6.46967 6.46967C6.76256 6.17678 7.23744 6.17678 7.53033 6.46967L12.5303 11.4697C12.8232 11.7626 12.8232 12.2374 12.5303 12.5303L7.53033 17.5303C7.23744 17.8232 6.76256 17.8232 6.46967 17.5303C6.17678 17.2374 6.17678 16.7626 6.46967 16.4697L10.9393 12L6.46967 7.53033ZM12.4697 7.53033C12.1768 7.23744 12.1768 6.76256 12.4697 6.46967C12.7626 6.17678 13.2374 6.17678 13.5303 6.46967L18.5303 11.4697C18.8232 11.7626 18.8232 12.2374 18.5303 12.5303L13.5303 17.5303C13.2374 17.8232 12.7626 17.8232 12.4697 17.5303C12.1768 17.2374 12.1768 16.7626 12.4697 16.4697L16.9393 12L12.4697 7.53033Z"
      />
    </Icon>
  );
};
